import ActivityTypesDelete from './ActivityTypesDelete';

export default ActivityTypesDelete;
